
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as auditeJ3jIP87gy_F7vlOHlzPxXVawYdF_45p_da_mu2ICL2F4Meta } from "/codebuild/output/src371685941/src/support-ui/pages/audit.vue?macro=true";
import { default as index0XBWuzDltgPQJiTeqEiLAxL8hjNnqEiMOSPJShMlTDEMeta } from "/codebuild/output/src371685941/src/support-ui/pages/index.vue?macro=true";
import { default as loginXJ2lIeDRONDvEjXpQSLG2DA7KGg967i7yI0O88oNyhsMeta } from "/codebuild/output/src371685941/src/support-ui/pages/login.vue?macro=true";
import { default as setupbzTZESXY6qYknJ3LTa6roNbYAmUN8RNQGagD09_459tw8Meta } from "/codebuild/output/src371685941/src/support-ui/pages/setup.vue?macro=true";
import { default as profilek_45455lg_45NByx6ZqWBr61ugpBSm6uBzbEQvi6R8bx6mcMeta } from "/codebuild/output/src371685941/src/support-ui/pages/profile.vue?macro=true";
import { default as _91_46_46_46slug_93VNlvA_45arTDJHNcwD0jFeIALra6fd313pcdfDpD1ovsQMeta } from "/codebuild/output/src371685941/src/support-ui/pages/[...slug].vue?macro=true";
import { default as onboardingHGEmSXrk1xhzo_4540M9g7m09_dTHvt_8TQ_453WHHkI9LEMeta } from "/codebuild/output/src371685941/src/support-ui/pages/onboarding.vue?macro=true";
import { default as indexopBrD8Oxw5lLfHf079tBH7UzK7jRJSHZCR6DTiGhGDUMeta } from "/codebuild/output/src371685941/src/support-ui/pages/admin/index.vue?macro=true";
import { default as _91id_93i_7iZi2maLbLdKQTbb6AejsoLgVB8l3fhq_451AdDWAUIMeta } from "/codebuild/output/src371685941/src/support-ui/pages/tickets/[id].vue?macro=true";
import { default as notificationsN75_HgJ7SXvyWeZpY1IK1FQrincgy_45et7g1Qy7Bwq_EMeta } from "/codebuild/output/src371685941/src/support-ui/pages/notifications.vue?macro=true";
import { default as indexOKTy_TfD6emMdtGzhzgXzPas_45LMwBK4Fvr7ouPcv6yIMeta } from "/codebuild/output/src371685941/src/support-ui/pages/tickets/index.vue?macro=true";
import { default as reset_45passwordNKeXNRPPbOwBPZCbHDmVmMj5AwkqfYXxh_YKpMi7UYEMeta } from "/codebuild/output/src371685941/src/support-ui/pages/reset-password.vue?macro=true";
import { default as indexI3IDt6sVLyCJD4a836VF2PNrQUrjjuXPDA5XHV9dZVQMeta } from "/codebuild/output/src371685941/src/support-ui/pages/admin/roles/index.vue?macro=true";
import { default as indexjAxQ_lk_45N7fWLvsalZXt0IpCM03p6Q0gLHiv5dnEo1kMeta } from "/codebuild/output/src371685941/src/support-ui/pages/admin/policies/index.vue?macro=true";
import { default as _91id_936ohhhc62HMJLpGySx5hgwLeLscYmByjB01VeZ9grvKEMeta } from "/codebuild/output/src371685941/src/support-ui/pages/admin/workflows/[id].vue?macro=true";
import { default as indexhf73ihfQqczEdM4IiAuUHuMKp9jbmaGxjCAAY1Ekc9kMeta } from "/codebuild/output/src371685941/src/support-ui/pages/admin/workflows/index.vue?macro=true";
import { default as indexMawWIt3wI1kg76cbwMj2LgSb6ZT1QT_45jK8kCOESIN2IMeta } from "/codebuild/output/src371685941/src/support-ui/pages/admin/departments/index.vue?macro=true";
import { default as _91ticketId_93zbxguurfTV1EXnikXjIK2CsxELqI3RQcwaKTmd5qDycMeta } from "/codebuild/output/src371685941/src/support-ui/pages/admin/ticket/[ticketId].vue?macro=true";
import { default as _91policyid_931Mc0gwFwqDWuBfLo3rI0JqmPOyrC9D0Fd1BmVOIWhccMeta } from "/codebuild/output/src371685941/src/support-ui/pages/admin/policies/[policyid].vue?macro=true";
import { default as indexbsYegwKP7EHkyoVhZaTqABKjdi8i84oGGMNGoFZYlbYMeta } from "/codebuild/output/src371685941/src/support-ui/pages/admin/user-management/index.vue?macro=true";
import { default as indexxZVOGl6sWsACmSCQXgzm6owKi5YKL6a0TlYL6Fn1LmIMeta } from "/codebuild/output/src371685941/src/support-ui/pages/admin/ticket/templates/index.vue?macro=true";
import { default as indexEaDdMpwhpPGBYcrLHgJOv6879JbRh2I1GVHJ7_45lV9sIMeta } from "/codebuild/output/src371685941/src/support-ui/pages/subscription-management/index.vue?macro=true";
import { default as _91templateId_93Ddqo49UfOyrSNnlaoJP_Oxhks0FrtyygbaX11Jd_45m_45oMeta } from "/codebuild/output/src371685941/src/support-ui/pages/admin/ticket/templates/[templateId].vue?macro=true";
import { default as _91planid_93jYU9LkU4Qv_wd2xPAj4HMVuCUV87Uli9CZPi2R1G2iAMeta } from "/codebuild/output/src371685941/src/support-ui/pages/subscription-management/plans/[planid].vue?macro=true";
import { default as _91departmentTitle_93_45_91departmentid_933FRlyaUB0SJ1iwKGMNB3Zax6pY09queujz5URTfKd_MMeta } from "/codebuild/output/src371685941/src/support-ui/pages/admin/user-management/departments/[departmentTitle]-[departmentid].vue?macro=true";
export default [
  {
    name: "audit",
    path: "/audit",
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/audit.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/login.vue")
  },
  {
    name: "setup",
    path: "/setup",
    meta: setupbzTZESXY6qYknJ3LTa6roNbYAmUN8RNQGagD09_459tw8Meta || {},
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/setup.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/profile.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/[...slug].vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboardingHGEmSXrk1xhzo_4540M9g7m09_dTHvt_8TQ_453WHHkI9LEMeta || {},
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/onboarding.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/admin/index.vue")
  },
  {
    name: "tickets-id",
    path: "/tickets/:id()",
    meta: _91id_93i_7iZi2maLbLdKQTbb6AejsoLgVB8l3fhq_451AdDWAUIMeta || {},
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/tickets/[id].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/notifications.vue")
  },
  {
    name: "tickets",
    path: "/tickets",
    meta: indexOKTy_TfD6emMdtGzhzgXzPas_45LMwBK4Fvr7ouPcv6yIMeta || {},
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/tickets/index.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/reset-password.vue")
  },
  {
    name: "admin-roles",
    path: "/admin/roles",
    meta: indexI3IDt6sVLyCJD4a836VF2PNrQUrjjuXPDA5XHV9dZVQMeta || {},
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/admin/roles/index.vue")
  },
  {
    name: "admin-policies",
    path: "/admin/policies",
    meta: indexjAxQ_lk_45N7fWLvsalZXt0IpCM03p6Q0gLHiv5dnEo1kMeta || {},
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/admin/policies/index.vue")
  },
  {
    name: "admin-workflows-id",
    path: "/admin/workflows/:id()",
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/admin/workflows/[id].vue")
  },
  {
    name: "admin-workflows",
    path: "/admin/workflows",
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/admin/workflows/index.vue")
  },
  {
    name: "admin-departments",
    path: "/admin/departments",
    meta: indexMawWIt3wI1kg76cbwMj2LgSb6ZT1QT_45jK8kCOESIN2IMeta || {},
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/admin/departments/index.vue")
  },
  {
    name: "admin-ticket-ticketId",
    path: "/admin/ticket/:ticketId()",
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/admin/ticket/[ticketId].vue")
  },
  {
    name: "admin-policies-policyid",
    path: "/admin/policies/:policyid()",
    meta: _91policyid_931Mc0gwFwqDWuBfLo3rI0JqmPOyrC9D0Fd1BmVOIWhccMeta || {},
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/admin/policies/[policyid].vue")
  },
  {
    name: "admin-user-management",
    path: "/admin/user-management",
    meta: indexbsYegwKP7EHkyoVhZaTqABKjdi8i84oGGMNGoFZYlbYMeta || {},
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/admin/user-management/index.vue")
  },
  {
    name: "admin-ticket-templates",
    path: "/admin/ticket/templates",
    meta: indexxZVOGl6sWsACmSCQXgzm6owKi5YKL6a0TlYL6Fn1LmIMeta || {},
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/admin/ticket/templates/index.vue")
  },
  {
    name: "subscription-management",
    path: "/subscription-management",
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/subscription-management/index.vue")
  },
  {
    name: "admin-ticket-templates-templateId",
    path: "/admin/ticket/templates/:templateId()",
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/admin/ticket/templates/[templateId].vue")
  },
  {
    name: "subscription-management-plans-planid",
    path: "/subscription-management/plans/:planid()",
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/subscription-management/plans/[planid].vue")
  },
  {
    name: "admin-user-management-departments-departmentTitle-departmentid",
    path: "/admin/user-management/departments/:departmentTitle()-:departmentid()",
    component: () => import("/codebuild/output/src371685941/src/support-ui/pages/admin/user-management/departments/[departmentTitle]-[departmentid].vue")
  }
]